import { render } from "./DayTable.vue?vue&type=template&id=610cf940&scoped=true"
import script from "./DayTable.vue?vue&type=script&lang=ts"
export * from "./DayTable.vue?vue&type=script&lang=ts"

import "./DayTable.vue?vue&type=style&index=0&id=610cf940&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-610cf940"

export default script